import Vue from 'vue';
import VueRouter from 'vue-router';
import rmdyAuth, { AUTH_ACTIONS } from '@rmdy/rmdy-authentication-frontend';
import { AUTH_GETTERS } from '@rmdy/rmdy-authentication-frontend/src/authentication.constants';
import ProjectList from '../views/projects/list/projects-list';
import ProjectDetail from '../views/projects/detail/projects-detail';
import RolesList from '../views/roles/list/roles-list';
import GroupsList from '../views/groups/list/groups-list';
import UsersList from '../views/users/list/users-list';
import store from '../store/index';

Vue.use(VueRouter);

const routes = [
	{
		path: '/login',
		name: 'login',
		component: () => import('../auth/login.vue')
	},
	{
		path: '/auth/callback',
		name: 'AuthCallback',
		component: () => import('../auth/authentication-callback.vue'),
	},
	{
		path: '/',
		redirect: '/projects',
	},
	{
		path: '/projects',
		name: 'Projects',
		component: ProjectList,
		meta: {
			authentication: true,
			adminAuthorization: true,
		},
	},
	{
		path: '/project/:id',
		name: 'Project Detail',
		component: ProjectDetail,
		meta: {
			authentication: true,
			adminAuthorization: true,
		},
	},
	{
		path: '/roles',
		name: 'Roles',
		component: RolesList,
		meta: {
			authentication: true,
			adminAuthorization: true,
		},
	},
	{
		path: '/groups',
		name: 'Groups',
		component: GroupsList,
		meta: {
			authentication: true,
			adminAuthorization: true,
		},
	},
	{
		path: '/users',
		name: 'Users',
		component: UsersList,
		meta: {
			authentication: true,
			adminAuthorization: true,
		},
	},
	{
		path: '/*',
		redirect: '/',
	},
];

const router = new VueRouter({
	mode: 'history',
	routes
});

router.beforeEach(async (to, from, next) => {
	// Check for privileges and auth requirements
	const authRequired = to.meta.authentication;
	const adminPrivsRequired = to.meta.adminAuthorization;

	const isLoggedIn = await store.getters[`${rmdyAuth.moduleName}/${AUTH_GETTERS.LOGGED_IN}`];
	const isAdmin = await store.getters[`${rmdyAuth.moduleName}/${AUTH_GETTERS.ROLES}`].includes('admin');

	// Check if auth required and user is logged in or admin rights are needed and user has no admin rights
	if ((authRequired && !isLoggedIn) || (adminPrivsRequired && !isAdmin)) {
		await store.dispatch(`${rmdyAuth.moduleName}/${AUTH_ACTIONS.LOGOUT}`);
		return router.push('/login');
	}

	// Allow access to next page
	return next();
});

export default router;
